import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "menu-seasons-component",
  class: "text-white fs-6 mt-4 mb-4"
}
const _hoisted_2 = { class: "row ms-0" }
const _hoisted_3 = { class: "col-12 red-color text-center" }
const _hoisted_4 = { class: "row ms-0" }
const _hoisted_5 = {
  class: "col-11 offset-1 border pt-2",
  id: "seasons-container"
}
const _hoisted_6 = { class: "ps-0" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "container-accordion" }
const _hoisted_9 = {
  id: 'gallery',
  class: "accordion-collapse collapse text-capitalize"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "container-accordion"
}
const _hoisted_12 = ["data-bs-target", "aria-controls", "onClick"]
const _hoisted_13 = ["id"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = {
  key: 1,
  class: "h-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (Object.keys(_ctx.seasonData).length > 0 && (_ctx.seasonData.seasons.length > 0 || _ctx.seasonData.has_gallery))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (_ctx.seasonData.gallery_seasons.length > 0)
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("button", {
                        class: "border-0 bg-transparent text-white ps-0 fw-light text-18px text-capitalize",
                        type: "button",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": '#gallery',
                        "aria-controls": '#gallery',
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onGalleryClicked(null)))
                      }, " Galerie "),
                      _createElementVNode("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasonData.gallery_seasons, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item,
                            class: "episodes text-18px",
                            onClick: ($event: any) => (_ctx.onGalleryClicked(item))
                          }, _toDisplayString(item), 9, _hoisted_10))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasonData.seasons, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.season
                }, [
                  (item.episodes.length > 0 || item.has_gallery)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("button", {
                          class: "border-0 bg-transparent text-white ps-0 fw-light text-18px text-capitalize",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": '#season-' + item.season.replace(' ', '-'),
                          "aria-controls": 'season-' + item.season.replace(' ', '-'),
                          onClick: ($event: any) => (_ctx.onSeasonClicked(item.season))
                        }, _toDisplayString(item.season), 9, _hoisted_12),
                        _createElementVNode("ul", {
                          id: 'season-' + item.season.replace(' ', '-'),
                          class: "accordion-collapse collapse"
                        }, [
                          (item.has_gallery)
                            ? (_openBlock(), _createElementBlock("li", {
                                key: 0,
                                class: "episodes text-18px text-capitalize",
                                onClick: ($event: any) => (_ctx.onGalleryClicked(item.season))
                              }, " Galerie ", 8, _hoisted_14))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.episodes, (episode) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: episode,
                              class: "episodes text-18px",
                              onClick: ($event: any) => (_ctx.onEpisodeClicked(item.season, episode))
                            }, " Episode " + _toDisplayString(episode), 9, _hoisted_15))
                          }), 128))
                        ], 8, _hoisted_13)
                      ]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "season-no-episodes text-18px text-capitalize",
                        onClick: ($event: any) => (_ctx.onSeasonClicked(item.season))
                      }, _toDisplayString(item.season), 9, _hoisted_16))
                ]))
              }), 128))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17))
}